import React, { useEffect } from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { PageHero } from '../../components/PageHero';
import { FileText, Calendar, Download, FolderOpen } from 'lucide-react';
import { motion } from 'framer-motion';
const documentGroups = [{
  category: 'Статутні документи',
  docs: [{
    title: 'Статут ФАіСУ (редакція 2025)',
    date: '10 грудня 2025'
  }, {
    title: 'Свідоцтво про реєстрацію',
    date: '15 березня 1991'
  }, {
    title: 'Положення про членство',
    date: '20 січня 2025'
  }]
}, {
  category: 'Нормативні документи',
  docs: [{
    title: 'Правила присвоєння спортивних розрядів',
    date: '1 лютого 2026'
  }, {
    title: 'Положення про змагання',
    date: '15 грудня 2025'
  }, {
    title: 'Стандарти безпеки при проведенні заходів',
    date: '10 жовтня 2025'
  }, {
    title: 'Кваліфікаційні вимоги до інструкторів',
    date: '5 вересня 2025'
  }]
}, {
  category: 'Фінансові документи',
  docs: [{
    title: 'Річний фінансовий звіт 2025',
    date: '28 січня 2026'
  }, {
    title: 'Бюджет на 2026 рік',
    date: '20 грудня 2025'
  }]
}];
export function Documents() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gray-50" data-id="element-736">
      <Header data-id="element-737" />
      <main className="pt-20" data-id="element-738">
        <PageHero label="Федерація" title="Документи" subtitle="Офіційні документи Федерації Альпінізму і Скелелазіння України" data-id="element-739" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-id="element-740">
          <div className="space-y-10" data-id="element-741">
            {documentGroups.map((group, gi) => <motion.div key={gi} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: gi * 0.1,
            duration: 0.4
          }} data-id="element-742">
                <div className="flex items-center gap-2 mb-4" data-id="element-743">
                  <FolderOpen className="h-4 w-4 text-primary/50" data-id="element-744" />
                  <h2 className="text-sm font-bold text-primary uppercase tracking-wider" data-id="element-745">
                    {group.category}
                  </h2>
                </div>
                <div className="space-y-3" data-id="element-746">
                  {group.docs.map((doc, di) => <div key={di} className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex items-center gap-4 group cursor-pointer" data-id="element-747">
                      <div className="p-2 bg-primary/5 rounded-lg border border-primary/10 flex-shrink-0" data-id="element-748">
                        <FileText className="h-4 w-4 text-primary" data-id="element-749" />
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-750">
                        <h3 className="text-sm font-medium text-gray-800 group-hover:text-primary transition-colors" data-id="element-751">
                          {doc.title}
                        </h3>
                        <div className="flex items-center gap-1.5 mt-1 text-gray-400 text-xs" data-id="element-752">
                          <Calendar className="h-3 w-3" data-id="element-753" />
                          {doc.date}
                        </div>
                      </div>
                      <button className="flex-shrink-0 p-2 text-gray-300 hover:text-primary transition-colors" title="Завантажити" data-id="element-754">
                        <Download className="h-4 w-4" data-id="element-755" />
                      </button>
                    </div>)}
                </div>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-756" />
    </div>;
}